export const ACTIONS = {
  SHOW_TOAST_MESSAGE: 'SHOW_TOAST_MESSAGE',
  HIDE_TOAST_MESSAGE: 'HIDE_TOAST_MESSAGE',
};

type ToastCtaListData = { text: string; onClick: () => void };

type ToastCtaList = ToastCtaListData[] | string | null;

type ToastMessageIcon = {
  icon: JSX.Element;
  placement: string;
  messageCardGap: number;
  toastZIndex: number;
};

export type NotificationToastData = {
  message: string;
  ctaList: ToastCtaList;
  timeout?: number | null;
  toastMetaData?: ToastMessageIcon | null;
};

type DispatchProps = {
  type: string;
  payload?: NotificationToastData;
};

type Dispatch = (dispatchProp: DispatchProps) => void;

export type ShowToast = (
  message: NotificationToastData['message'],
  ctaList: ToastCtaList,
  timeout?: NotificationToastData['timeout'],
  toastMetaData?: NotificationToastData['toastMetaData'],
) => void;

export const showToast = (
  message: NotificationToastData['message'],
  ctaList: ToastCtaList,
  timeout?: NotificationToastData['timeout'],
  toastMetaData?: NotificationToastData['toastMetaData'],
) => ({
  type: ACTIONS.SHOW_TOAST_MESSAGE,
  payload: {
    message,
    ctaList,
    timeout,
    toastMetaData,
  },
});
export const hideToast = () => (dispatch: Dispatch) => {
  dispatch({
    type: ACTIONS.HIDE_TOAST_MESSAGE,
  });
};
